import { useFreeformHandlers } from "../other/useFreeformHandlers";
import type { SlideHandlers } from "../types";

/**
 * Handlers for phonics slide type
 * Currently uses the same canvas-based approach as grammar slides
 * Customize here if phonics slides need different behavior
 */
export const usePhonicsHandlers = (): SlideHandlers => {
  return useFreeformHandlers();
};
